export const ArrowForwardIcon = () => {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.99967 0.833252L5.82467 2.00825L10.4747 6.66658H0.333008V8.33325H10.4747L5.82467 12.9916L6.99967 14.1666L13.6663 7.49992L6.99967 0.833252Z"
        fill="#003734"
      />
    </svg>
  );
};
//
